var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftColorFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70533 11.6674C8.51116 11.6674 9.16366 12.3207 9.16366 13.1257V16.0424C9.16366 16.4292 9.01001 16.8001 8.73652 17.0736C8.46303 17.3471 8.0921 17.5007 7.70533 17.5007H3.12533C2.73855 17.5007 2.36762 17.3471 2.09413 17.0736C1.82064 16.8001 1.66699 16.4292 1.66699 16.0424V13.1257C1.66699 12.3207 2.32033 11.6674 3.12533 11.6674H7.70533V11.6674ZM16.8753 11.6674C17.6803 11.6674 18.3337 12.3207 18.3337 13.1257V16.0424C18.3337 16.4292 18.18 16.8001 17.9065 17.0736C17.633 17.3471 17.2621 17.5007 16.8753 17.5007H12.2953C11.9086 17.5007 11.5376 17.3471 11.2641 17.0736C10.9906 16.8001 10.837 16.4292 10.837 16.0424V13.1257C10.837 12.3207 11.4895 11.6674 12.2953 11.6674H16.8753V11.6674ZM16.8753 2.49658C17.6803 2.49658 18.3337 3.14992 18.3337 3.95492V8.54075C18.3338 8.73233 18.2961 8.92206 18.2229 9.09908C18.1497 9.27611 18.0422 9.43698 17.9068 9.57248C17.7714 9.70799 17.6106 9.81549 17.4336 9.88883C17.2566 9.96217 17.0669 9.99991 16.8753 9.99991H3.12533C2.73855 9.99991 2.36762 9.84627 2.09413 9.57278C1.82064 9.29929 1.66699 8.92836 1.66699 8.54158V3.95492C1.66701 3.58892 1.80463 3.23632 2.05256 2.96709C2.30048 2.69786 2.64058 2.5317 3.00533 2.50158L3.12533 2.49658H16.8753V2.49658Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70533 11.6674C8.51116 11.6674 9.16366 12.3207 9.16366 13.1257V16.0424C9.16366 16.4292 9.01001 16.8001 8.73652 17.0736C8.46303 17.3471 8.0921 17.5007 7.70533 17.5007H3.12533C2.73855 17.5007 2.36762 17.3471 2.09413 17.0736C1.82064 16.8001 1.66699 16.4292 1.66699 16.0424V13.1257C1.66699 12.3207 2.32033 11.6674 3.12533 11.6674H7.70533V11.6674ZM16.8753 11.6674C17.6803 11.6674 18.3337 12.3207 18.3337 13.1257V16.0424C18.3337 16.4292 18.18 16.8001 17.9065 17.0736C17.633 17.3471 17.2621 17.5007 16.8753 17.5007H12.2953C11.9086 17.5007 11.5376 17.3471 11.2641 17.0736C10.9906 16.8001 10.837 16.4292 10.837 16.0424V13.1257C10.837 12.3207 11.4895 11.6674 12.2953 11.6674H16.8753V11.6674ZM16.8753 2.49658C17.6803 2.49658 18.3337 3.14992 18.3337 3.95492V8.54075C18.3338 8.73233 18.2961 8.92206 18.2229 9.09908C18.1497 9.27611 18.0422 9.43698 17.9068 9.57248C17.7714 9.70799 17.6106 9.81549 17.4336 9.88883C17.2566 9.96217 17.0669 9.99991 16.8753 9.99991H3.12533C2.73855 9.99991 2.36762 9.84627 2.09413 9.57278C1.82064 9.29929 1.66699 8.92836 1.66699 8.54158V3.95492C1.66701 3.58892 1.80463 3.23632 2.05256 2.96709C2.30048 2.69786 2.64058 2.5317 3.00533 2.50158L3.12533 2.49658H16.8753V2.49658Z",
    fill: "url(#paint0_linear_1394_105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1394_105",
    x1: 1.5,
    y1: 2.5,
    x2: 20.2159,
    y2: 7.21157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#E9A134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#8DC064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#6427E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA33E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftColorFeed);
export default __webpack_public_path__ + "static/media/nftColorFeed.05b285e88f430299c5cd6363a0f4b92e.svg";
export { ForwardRef as ReactComponent };